<template>
    <el-row class="roleManage">
        <el-row class="table">
              <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>权限管理</span>
                <div>
                  <el-button  type="primary" @click="addEvent">新增</el-button>
                </div>
              </div>
              <div class="text item">
                <el-table
                  :data="tableData"
                  style="width: 100%">
                  <el-table-column
                    fixed
                    prop="type"
                    label="权限类型">
                  </el-table-column>
                  <el-table-column
                    prop="group_name"
                    label="钉钉分组">
                  </el-table-column>
                  <el-table-column
                    prop="user_name"
                    label="姓名">
                  </el-table-column>
                  <el-table-column
                    prop="remark"
                    label="描述">
                  </el-table-column>
                  <el-table-column
                    fixed="right"
                    label="操作"
                    width="150">
                    <template slot-scope="scope">
                      <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                      <el-button type="text" size="small">
                        <el-popconfirm confirm-button-text='是的' cancel-button-text='取消' icon="el-icon-info"
                              icon-color="#66b1ff" title="您确认删除该权限么？" @confirm="delateEvent(scope.row)">
                              <el-button slot="reference" type="text" size="small">删除</el-button>
                        </el-popconfirm>
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-card>
        </el-row>
    </el-row>
</template>

<script>

import { getPowerTable,powerRemove,getRoleUser,getRole } from '../../utils/api'
export default {
  components: {},
  props: {},
  data() {
    return {
      tableData:[],
      page:1,
      userDatatype:[],
      roleDatatype:[]
    };
  },
  watch: {},
  computed: {},
  methods: {
    //新增
    addEvent(){
      this.$router.push({name:'rolePermission',params:{status:0}})
    },
    // 编辑
    editClick(row){
      this.$router.push({name:'rolePermission',params:{status:1,row}})
    },
    //删除
    delateEvent(row){
      console.log(row,'删除');
      var that = this
      var params = {
        id : row.id
      }
      powerRemove(params)
      .then(res=>{
        console.log(res,'移除权限');
        if(res.message.status == 'success'){
          that.$message.success('移除成功')
          that.getPowerList()
        }else{
          that.$message.error(res.message.text)
        }
      })
      .catch(err=>{
        console.log(err,'err');
      })
    },
    //获取权限列表
    getPowerList(){
      var that = this
      var param = {
        page:that.page,
        pagesize:999
      }
      getPowerTable(param)
      .then(res=>{
        console.log(res,'权限列表');
        if(res.message.status == 'success'){
            that.tableData = res.data
            that.tableData.forEach(item=>{
              if(item.type == 1){
                item.type = '组权限'
              }else{
                item.type = '用户权限'
              }
            })
        }else{
          that.tableData = []
        }
      })
      .catch(err=>{
        console.log(err,'err');
      })
    },
    //获取角色列表
    getRoleTable(){
        var that = this
        getRole()
        .then(res=>{
            if(res.message.status == 'success'){
                console.log(res,'角色列表');
                that.userDatatype = [] //角色
                that.roleDatatype = [] //用户
                res.data.forEach(item=>{
                    that.userDatatype.push({text:item.name,value:item.id})
                    that.roleDatatype.push({value:item.id,label:item.name})
                })
                that.roleDatatype.forEach(item=>{
                    that.getRoleUserTable(item.value)
                })
                that.$store.state.roleDatatype =  that.roleDatatype
                console.log(that.$store.state.roleDatatype,'that.$store.state.roleDatatype');
            }
        })
        .catch(err=>{
            console.log(err,'err');
        })
    },
    //获取用户列表
    getRoleUserTable(id){
        var that = this
        var params = {
            role_id:id
        }
        var arr = []
        getRoleUser(params)
        .then(res=>{
            if(res.message.status == 'success'){
                if(res.data){
                    res.data.forEach(item=>{
                      arr.push({value:item.userid,label:item.name})
                })
                }
                that.roleDatatype.forEach(item=>{
                    if(item.value == id){
                        item['children'] = arr
                    }
                })
            }
        })
        .catch(err=>{
            console.log(err,'err');
        })
    },




  },
  created() {},
  mounted() {
    this.getRoleTable()
  },
  activated(){
    this.getPowerList()
  }
  
};
</script>
<style lang="scss" scoped>
.roleManage{
   .clearfix{
      display: flex;
      justify-content: space-between;
      align-items: center;
   }
}
</style>